function initFaqs() {
    const plusSVG = `
    <svg class="faq-plus w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33" fill="none">
        <path d="M31.7109 15.2109H17.7891V1.28906C17.7891 0.577113 17.2119 0 16.5 0C15.7881 0 15.2109 0.577113 15.2109 1.28906V15.2109H1.28906C0.577113 15.2109 0 15.7881 0 16.5C0 17.2119 0.577113 17.7891 1.28906 17.7891H15.2109V31.7109C15.2109 32.4229 15.7881 33 16.5 33C17.2119 33 17.7891 32.4229 17.7891 31.7109V17.7891H31.7109C32.4229 17.7891 33 17.2119 33 16.5C33 15.7881 32.4229 15.2109 31.7109 15.2109Z" fill="#6D2209"/>
    </svg>`;

    const minusSVG = `
    <svg class="faq-minus w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33" fill="none">
        <path d="M31.7109 15.2109H1.28906C0.577113 15.2109 0 15.7881 0 16.5C0 17.2119 0.577113 17.7891 1.28906 17.7891H31.7109C32.4229 17.7891 33 17.2119 33 16.5C33 15.7881 32.4229 15.2109 31.7109 15.2109Z" fill="#6D2209"/>
    </svg>`;

    // Use event delegation for dynamic content/Shopify editor
    $(document).off('click.yaynutsFaq').on('click.yaynutsFaq', '.faq-item', function () {
        const $item = $(this);
        const $content = $item.find('.faq-content');
        const $icon = $item.find('span:last-child');

        const isOpen = !$content.hasClass('hidden');

        // Close all in the same section
        $item.closest('.divide-y').find('.faq-item').each(function () {
            $(this).find('.faq-content').addClass('hidden');
            $(this).find('span:last-child').html(plusSVG);
        });

        // Open current if it was closed
        if (!isOpen) {
            $content.removeClass('hidden');
            $icon.html(minusSVG);
        }
    });
}

$(document).ready(function () {
    initFaqs();
});

// Shopify Theme Editor support
document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.faq-item')) {
        initFaqs();
    }
});